import { Divider, Stack, Typography } from 'ui';

import type { TransportPriceEstimateError } from '../../types';
import { BuyerOfferDrawerSection } from '../BuyerOfferDrawerSection/BuyerOfferDrawerSection';
import { DealMarginDrawerSection } from '../DealMarginDrawerSection/DealMarginDrawerSection';
import { SellerOfferDrawerSection } from '../SellerOfferDrawerSection/SellerOfferDrawerSection';
import { TransportCostDrawerSection } from '../TransportCostDrawerSection/TransportCostDrawerSection';

type Props = {
  onTransportPriceUpdate: () => void;
  isTransportPriceLoading: boolean;
  estimateTransportPrice: () => void;
  transportPriceError: TransportPriceEstimateError;
};
export const DealCalculatorDrawerSection = ({
  estimateTransportPrice,
  onTransportPriceUpdate,
  transportPriceError,
  isTransportPriceLoading,
}: Props) => {
  return (
    <Stack gap={2}>
      <Typography color="text.secondary">Deal calculator</Typography>
      <TransportCostDrawerSection
        onTransportPriceUpdate={onTransportPriceUpdate}
        transportPriceError={transportPriceError}
      />
      <SellerOfferDrawerSection
        isTransportPriceLoading={isTransportPriceLoading}
        estimateTransportPrice={estimateTransportPrice}
      />
      <BuyerOfferDrawerSection estimateTransportPrice={estimateTransportPrice} />
      <DealMarginDrawerSection />
      <Divider />
    </Stack>
  );
};
